<template>
    <b-overlay :show="showoverlay" rounded="sm">
        <b-form @submit.stop.prevent="onSubmit">
            <div class="clearfix">
                <div class="col-md-12">
                    <div class="row clearfix">
                        <div class="col-md-3">
                            <b-form-group id="financial_year-group" label="Financial Year" label-for="financial_year" class="required-field">
                                <b-form-select  name="financial_year" class='form-control' v-model="fdata.financial_year" :options="financial_year_list" v-validate="{ required: true }" :state="validateState('financial_year')" aria-describedby="financial_year-feedback" data-vv-as="Financial Year">
                                </b-form-select>
                                <b-form-invalid-feedback id="financial_year-feedback">{{ veeErrors.first('financial_year') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>

                        <div class="col-md-3">
                            <b-form-group id="month-group" label="Month" label-for="month" class="required-field">
                                <b-form-select  name="month" class='form-control' v-model="fdata.month" :options="month_list" v-validate="{ required: true }" :state="validateState('month')" aria-describedby="month-feedback" data-vv-as="Month">
                                </b-form-select>
                                <b-form-invalid-feedback id="month-feedback">{{ veeErrors.first('month') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>

                        <div class="col-md-6">
                            <b-form-group id="run_date-group" label="Run Date" label-for="run_date"  class="required-field">
                                <b-input-group class="mb-3" >
                                    <b-form-input id="run_date" name="run_date" v-model="fdata.run_date" v-validate="{ required: true, date_format: 'yyyy-mm-dd' }" type="text" placeholder="YYYY-MM-DD" autocomplete="off" :state="validateState('run_date')" aria-describedby="run_date-feedback" data-vv-as="Opening Balance Date"></b-form-input>
                                    <b-input-group-append>
                                        <b-form-datepicker id="day_one" button-only right locale="en-US" v-model="fdata.run_date"></b-form-datepicker>
                                    </b-input-group-append>
                                    <b-form-invalid-feedback id="run_date-feedback">{{ veeErrors.first('run_date') }}</b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>
                        </div>

                        <div class="col-md-6" v-if="gf_type=='monthly'">
                            <b-form-group id="type_of_run-group" label="Type of Run" label-for="type_of_run" class="required-field">
                                <b-form-select  name="type_of_run" class='form-control' v-model="fdata.type_of_run" :options="run_type_list" v-validate="{ required: true }" :state="validateState('type_of_run')" aria-describedby="type_of_run-feedback" data-vv-as="Type of Run">
                                </b-form-select>
                                <b-form-invalid-feedback id="type_of_run-feedback">{{ veeErrors.first('type_of_run') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>

                        <div class="col-md-6" v-if="gf_type=='monthly'"></div>

                        <div class="col-md-6 float-left">

                                <dl v-if="gf_type=='monthly'" class="row clearfix mt-3 company-form-container no-border no-shadow">
                                    <dt class="col-md-12 pl-0 pr-0">Contribution Process</dt>
                                    <dd class="col-md-12 pl-0 pr-0 mb-4">{{ contribution_policy_label }}</dd>
                                </dl>

                                <dl v-else class="row clearfix mt-3 company-form-container no-border no-shadow">
                                    <dt class="col-md-12 pl-0 pr-0">Type of Run</dt>
                                    <dd class="col-md-12 pl-0 pr-0 mb-4">One-Off</dd>
                                </dl>

                                <b-form-group id="details_and_description-group" label="Details and Description" label-for="details_and_description" class="">
                                    <b-form-input id="details_and_description" name="details_and_description" v-model="fdata.details_and_description" v-validate="{ }" :state="validateState('details_and_description')" aria-describedby="details_and_description-feedback" data-vv-as="Details and Description" placeholder="Please Enter Details"></b-form-input>
                                    <b-form-invalid-feedback id="details_and_description-feedback">{{ veeErrors.first('details_and_description') }}</b-form-invalid-feedback>
                                </b-form-group>

                            </div>

                            <div class="col-md-6 float-right">

                                <template v-if="fdata.type_of_run == 1 && gf_type=='monthly'">
                                    <b-form-group id="contribution_amount-group" label="Contribution Amount" class="" label-for="contribution_amount">
                                        <b-form-input id="contribution_amount" name="contribution_amount" v-model="fdata.contribution_amount" :disabled="true" v-validate="{ regex: /^[0-9]*\.?[0-9]{0,2}$/ }" :state="validateState('contribution_amount')" aria-describedby="contribution_amount-feedback" data-vv-as="Contribution Amount"></b-form-input>
                                        <b-form-invalid-feedback id="contribution_amount-feedback">{{ veeErrors.first('contribution_amount') }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </template>

                                <template v-else>
                                    <b-form-group id="contribution_amount-group" label="Contribution Amount" class="required-field" label-for="contribution_amount">
                                        <b-form-input id="contribution_amount" name="contribution_amount" v-model="fdata.contribution_amount" v-validate="{ required: true, regex: /^[0-9]*\.?[0-9]{0,2}$/ }" :state="validateState('contribution_amount')" aria-describedby="contribution_amount-feedback" data-vv-as="Contribution Amount"></b-form-input>
                                        <b-form-invalid-feedback id="contribution_amount-feedback">{{ veeErrors.first('contribution_amount') }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </template>

                                <file-component ref="fileinput" :labelname="this.attachment" :accept="this.accept" :multiple="this.multiple" v-on:childToParent="listReturnAttachment"></file-component>

                            </div>
                        </div>

                    </div>

                <div class="col-md-12 float-right">
                    <div class="col-md-12 text-center mt-5">
                        <b-button type="submit" class="btn-primary" variant="success"> Process Run </b-button>
                    </div>
                </div>
            </div>

        </b-form>
    </b-overlay>
</template>

<script>
    export default {
        // Start: Rejwan: 24-05-2025 Gf Run
        mounted() {
            if (this.gf_type === 'oneoff') {
                this.fdata.type_of_run = 3;
            }
        },
        // End: Rejwan: 24-05-2025 Gf Run

        props: ['gf_type', 'gf_run_id'],
        data() {
            return {
                showoverlay: false,

                fdata: { type_of_run: 1, financial_year:null, month:null, details_and_description: null}, // Sifat: 02-07-2025 Error submit montly contribution run
                accept:".jpg, .png, .gif, .pdf , .doc , .docx",
                attachment: 'Attachments',
                multiple:true,

                month_list: [
                    {value:null, text: "Please Select"},
                    {value: "1", text: "January"},
                    {value: "2", text: "February"},
                    {value: "3", text: "March"},
                    {value: "4", text: "April"},
                    {value: "5", text: "May"},
                    {value: "6", text: "June"},
                    {value: "7", text: "July"},
                    {value: "8", text: "August"},
                    {value: "9", text: "September"},
                    {value: "10", text: "October"},
                    {value: "11", text: "November"},
                    {value: "12", text: "December"},
                ],

                // Start: Rejwan: 24-05-2025 Gf Run
                // End: Rejwan: 24-05-2025 Gf Run

                run_type_list: [
                    {value: "1", text: "Regular"},
                    {value: "2", text: "Manual"},
                ],

                contribution_process_list: [
                    {value: "1", text: "Actuarial Rate Based Contribution"},
                    {value: "2", text: "One-Off"},
                ],

                // Start: Rejwan: 24-05-2025 GF Run
                // accept:".jpg, .png, .gif, .pdf , .doc , .docx",
                // attachment: 'Attachments',
                // multiple:false,
                // attachment: 'Upload File',
                document: null,
                contribution_policy_label: 'Actuarial Rate Based Contribution',
                // End: Rejwan: 24-05-2025 GF Run
            }
        },

        methods: {
            loadGfContributionPolicy() {
                axios.get(this.$api_url + '/load-site-options').then(response => {
                    response.data.forEach(o => {
                        if (o.opt_key === 'gf_contribution_policy') {
                            const val = parseInt(o.opt_value);
                            const policies = {
                                1: 'Direct Balance Contribution',
                                2: 'Dynamic Proportion Based Contribution',
                                3: 'Actuarial Amount Based Contribution',
                                4: 'Actuarial Rate Based Contribution'
                            };
                            this.contribution_policy_label = policies[val] || 'Actuarial Rate Based Contribution';
                        }
                    });
                });
            },
            // Start: Rejwan: 24-05-2025 GF Run
            // listReturnAttachment:function (data) {},
            listReturnAttachment:function (data) {
                this.document = data;
            },
            // End: Rejwan: 24-05-2025 GF Run

            validateState(ref) {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },

            onSubmit(e) {
                // Start: Rejwan: 24-05-2025 GF Run
                if (!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    // if(this.fdata.details_and_description == null){
                    //     return;
                    // }

                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.fdata)) {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                    }

                    if (this.document && this.document.length) {
                        this.document.forEach((file, index) => {
                            formData.append('document[]', file);
                        });
                    } else {
                        formData.append('document', '');
                    }

                    // Start: Rejwan

                    let url;
                    if(this.gf_run_id) {
                        formData.append('update_all', '1');
                        formData.append('id', this.gf_run_id);
                        url = this.$api_url+'/gf/run/update';
                    } else {
                        url = this.$api_url+'/gf/run/save'
                    }
                    // End: Rejwan
                    // axios.post(this.$api_url +'/gf/run/save', formData)
                    axios.post(url, formData)
                    .then(function (response)
                    {
                       if(response.data.success == true) {
                            // this.$bvToast.toast(response.data.message, {
                            //     title: `Success`,
                            //     variant: 'success',
                            //     solid: true
                            // });
                            // if(this.gf_run_id) {
                            //     this.$emit('listReturn', response.data);
                            // } else {
                            //     this.$emit('listReturn', 'run_form');
                            // }
                            this.$emit('listReturn', response.data);
                        } else {

                            //Start: Sifat: 02-07-2025 Make monthly contribution run functional
                            this.$bvToast.toast(response.data.error, {
                                title: 'Error!',
                                variant: 'danger',
                                solid: true
                            });
                            //End:  Sifat: 02-07-2025 Make monthly contribution run functional
                        }
                    }.bind(this))
                    .catch(function (error) {
                        let message = 'Something went wrong.';
                        if (error.response && error.response.data) {
                            if (error.response.data.message) {
                                message = error.response.data.message;
                            } else if (error.response.data.error) {
                                message = error.response.data.error;
                            }
                        }
                        this.$bvToast.toast(message, {
                            title: 'Error!',
                            variant: 'danger',
                            solid: true
                        });
                    }.bind(this))
                });

                // End: Rejwan: 24-05-2025 GF Run
            },

        },
        created: function () {
            this.loadGfContributionPolicy();
            this.$nextTick(() => {

                if(this.gf_run_id) {
                    let currentObj = this;
                    axios.get(this.$api_url+'/gf/run/details', {
                        params: {
                            id: this.gf_run_id
                        }
                    }).then(function (response) {
                        this.fdata.type_of_run = response.data.run_type;
                        this.fdata.financial_year = response.data.fiscal_year;
                        this.fdata.month = response.data.month;
                        this.fdata.run_date = response.data.run_date;
                        this.fdata.details_and_description = response.data.details;
                        this.fdata.contribution_amount = response.data.amount;
                    }.bind(this))
                    .catch(function (error)
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
                }

            });

        },
        computed: {
            financial_year_list() {
                let startYear = 2020;
                let currentYear = new Date().getFullYear();
                let activeEndYear = new Date().getMonth() >= 6 ? currentYear + 1 : currentYear;
                let list = [{ value: null, text: "Please Select" }];
                for (let y = startYear; y <= activeEndYear; y++) {
                    let val = `${y}-${y + 1}`;
                    list.push({ value: val, text: val });
                }
                return list;
            }
        }

    }

</script>
